import { createContext, useContext, useCallback } from 'react';

const SequencesContext = createContext({ get: (id) => {}, next: (id) => {}, getAll: () => {}, isLast: () => {} });

export const useSequences = () => {
  return useContext(SequencesContext);
};

export const SequencesProvider = ({ children, brief }) => {
  const videoInstructions = brief?.instructions?.filter(({ type }) => type === 'VIDEO').map(({ text }) => text);
  const audioInstructions = brief?.instructions?.filter(({ type }) => type === 'AUDIO').map(({ text }) => text);
  const sequences = (brief?.sequences || []).map((e, idx) => ({
    ...e,
    index: idx + 1,
    total: brief?.sequences?.length || 0,
    instructions: e.type === 'VIDEO' ? videoInstructions : audioInstructions,
  }));

  const get = useCallback((id) => sequences.find((s) => s.id === id), [sequences]);
  const getAll = useCallback(() => sequences, [sequences]);
  const isLast = useCallback(
    (id) => {
      const currentIndex = sequences.findIndex((s) => id === s.id);
      return currentIndex === sequences.length - 1;
    },
    [sequences]
  );
  const next = useCallback(
    (id) => {
      const currentIndex = sequences.findIndex((s) => id === s.id);
      return currentIndex < sequences.length - 1 ? sequences[currentIndex + 1] : null;
    },
    [sequences]
  );

  return <SequencesContext.Provider value={{ get, getAll, next, isLast }}>{children}</SequencesContext.Provider>;
};
